import React, { useEffect } from "react";
import { validateProps } from "../../../../shared/props";
import { warnDeprecation } from "../../../../shared/warnDeprecation";
import { useViewport } from "../../../../styles";
import { ActionButton } from "../../../Buttons/ActionButton/ActionButton";
import { IconButton, IconButtonProps } from "../../../Buttons/IconButton/IconButton";
import { BaseFeedListItem, FeedListItemProps } from "../shared/BaseFeedListItem";

export interface SimpleFeedListItemProps extends FeedListItemProps { }

/** @deprecated Please use the new ListItem/MobileListItem with ListItemColumns instead. */
export const SimpleFeedListItem: React.FC<SimpleFeedListItemProps> = ({
    image,
    text,
    actionProps,
    ...otherProps
}) => {
    validateProps("SimpleFeedListItem", otherProps);

    useEffect(() => {
        warnDeprecation("SimpleFeedListItem has been deprecated, please use the new ListItem/MobileListItem with ListItemColumns instead.");
    }, []);

    const viewportType = useViewport();

    let action: JSX.Element;
    if (["s", "m"].includes(viewportType)) {
        action = <IconButton key="iconAction" {...(actionProps as IconButtonProps)} />;
    } else {
        action = <ActionButton key="buttonAction" {...actionProps} />;
    }

    return (
        <BaseFeedListItem
            image={image}
            actions={[action]}
            {...otherProps}
        >
            {text}
        </BaseFeedListItem>
    );
};
